import EfVideo from '@elem/ui/ef-video';
import css from './index.module.scss';
import EfSpec from '@elem/ui/ef-spec';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';

export default function B() {
    const { t } = useLang('delta_pro_ultra.launch.detail.OASIS');
    const [source, setSource] = useState(['', '']);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scene = AniContainer.create({
                triggerElement: '.shp2-detail-C',
                triggerHook: 1,
                offset: '100%',
                onEnter: () =>
                    setSource(
                        window?.innerWidth > 1024
                            ? [
                                  'https://websiteoss.ecoflow.com/upload/video/1735633579374/SmartBackup2.mp4',
                                  'https://websiteoss.ecoflow.com/upload/video/1735633579205/SmartBackup3.mp4',
                              ]
                            : [
                                  'https://websiteoss.ecoflow.com/upload/video/1735633587796/SmartBackup2-h5.mp4',
                                  'https://websiteoss.ecoflow.com/upload/video/1735633587623/SmartBackup3-h5.mp4',
                              ],
                    ),
            });

            const scene2 = AniContainer.create({
                triggerElement: '.OASIS-D',
                triggerHook: 1,
                offset: '120%',
                duration: '5%',
                syncFromTo: [['.OASIS-D .video-box .video2', { opacity: 0 }, { opacity: 1 }]],
            });
            return () => {
                scene.destroy();
                scene2.destroy();
            };
        }
    }, []);

    return (
        <>
            <EfSpec />
            <section className={`OASIS-D ${css['OASIS-D']}`}>
                <div className="sticky">
                    <div className="info">
                        <h2 className="title">{t('B_title')}</h2>
                        <p className="desc">{t('B_desc')}</p>
                    </div>
                    <div className="video-box">
                        <div className="video1">
                            {source[0] && (
                                <EfVideo
                                    pc={source[0]}
                                    poster="https://websiteoss.ecoflow.com/upload/image/1735636448957/SmartBackup2-poster.jpg"
                                    posterH5="https://websiteoss.ecoflow.com/upload/image/1735637623434/SmartBackup2-poster-h5.jpg"
                                    loop={true}
                                    autoPlay={true}
                                />
                            )}
                        </div>
                        <div className="video2">
                            {source[1] && (
                                <EfVideo
                                    pc={source[1]}
                                    poster="https://websiteoss.ecoflow.com/upload/image/1735636449294/SmartBackup3-poster.jpg"
                                    posterH5="https://websiteoss.ecoflow.com/upload/image/1735637623261/SmartBackup3-poster-h5.jpg"
                                    loop={true}
                                    autoPlay={true}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
